import React, { useRef, useState } from 'react';
import { adminApi, buildImageUrl } from '../../api/client';
import { Upload, X, Loader2 } from 'lucide-react';

export default function ImageUpload({ value, onChange, label = 'Səkil' }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr('');
    setUploading(true);
    try {
      const res = await adminApi.upload(file);
      onChange(res.url);
    } catch (ex) {
      setErr(ex?.response?.data?.detail || 'Yükləmə xtası');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#374151' }}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {value ? (
          <div style={{ position: 'relative', width: 96, height: 72, borderRadius: 6, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
            <img src={buildImageUrl(value)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <button type="button" onClick={() => onChange('')} style={{ position: 'absolute', top: 2, right: 2, background: 'rgba(0,0,0,0.6)', border: 'none', color: '#fff', borderRadius: '50%', width: 20, height: 20, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><X size={12} /></button>
          </div>
        ) : (
          <div style={{ width: 96, height: 72, background: '#f3f4f6', border: '1px dashed #d1d5db', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: 11 }}>Yoxdur</div>
        )}
        <div>
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
          <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', border: '1px solid #17b4b4', background: '#fff', color: '#17b4b4', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            {uploading ? <Loader2 size={14} className="spin" /> : <Upload size={14} />}
            {uploading ? 'Yüklənir...' : 'Səkil seç'}
          </button>
          <input
            type="text" placeholder="və ya URL yapışdır" value={value || ''} onChange={(e) => onChange(e.target.value)}
            style={{ display: 'block', marginTop: 6, width: 280, padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: 6, fontSize: 12 }}
          />
        </div>
      </div>
      {err && <p style={{ color: '#dc2626', fontSize: 12, margin: '6px 0 0' }}>{err}</p>}
    </div>
  );
}
